import { render } from "./InformationsComponent.vue?vue&type=template&id=665bbb84"
import script from "./InformationsComponent.vue?vue&type=script&lang=js"
export * from "./InformationsComponent.vue?vue&type=script&lang=js"

import "./InformationsComponent.vue?vue&type=style&index=0&id=665bbb84&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__